import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { ROUTE_USER_LOGIN, ROUTE_USER_LOGOUT } from "../../constants/route";
import { logoutUser } from "../../slices/auth/login/action";
const ProfileDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user || {});

  const getInitials = (fullName) => {
    if (!fullName) return "";
    const names = fullName.split(" ");
    const initials = names
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    return initials.slice(0, 2); // Limit to 2 characters
  };

  const handleLogout = async () => {
    dispatch(logoutUser()); // Dispatch the logout action
    // navigate(ROUTE_USER_LOGIN); // Redirect to login page
  };
  return (
    <UncontrolledDropdown group>
      <DropdownToggle
        size="sm"
        color="soft-dark"
        className="shadow-none d-flex justify-content-center align-items-center rounded-circle"
        style={{ width: "36px", height: "36px" }}
      >
        <span>{getInitials(user?.name)}</span>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem header className="text-muted fs-11">
          Welcome {user?.name}!
        </DropdownItem>
        <DropdownItem className="fs-14" onClick={() => navigate("/campaigns")}>
          Campaigns
        </DropdownItem>

        <DropdownItem className="fs-14" onClick={() => navigate("/statements")}>
          Statements
        </DropdownItem>

        <DropdownItem className="fs-14" onClick={() => navigate("/members")}>
          Members
        </DropdownItem>

        <DropdownItem
          className="fs-14"
          onClick={() => navigate("/settings/profile")}
        >
          Profile
        </DropdownItem>

        <DropdownItem divider />
        <DropdownItem
          className="fs-14"
          onClick={() => handleLogout(ROUTE_USER_LOGOUT)}
        >
          <i className="fs-18 lh-sm bx bx-power-off text-muted s align-middle me-1"></i>{" "}
          Logout
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
export default ProfileDropdown;
